import React from 'react'
import '../index.scss'

const SlotRowSkeleton: React.FC<{
  slots?: number
  isLast?: boolean
}> = ({ slots = 5, isLast = false }) => {
  return (
    <div
      className={`~w-full ~flex ~flex-wrap ~justify-between ${
        slots === 5 ? '~gap-2' : '~gap-4'
      } ${isLast ? '' : '~mb-3'}`}
    >
      {Array(slots)
        .fill(null)
        .map((_, idx) => {
          return (
            <div
              key={idx}
              className={`~box-border animateSlot ~h-[37px] ${
                slots === 5
                  ? '~min-w-[calc(100%/5-8px)]' // 5 slots with 8px spacing
                  : '~min-w-[calc(100%/3-16px)]' // 3 slots with 16px spacing
              } ~rounded-xs`}
            />
          )
        })}
    </div>
  )
}

export default SlotRowSkeleton
